export const abbreviateProductSize = (size: string) => {
  const matches = size.match(/^X{2,}/);

  if (matches) {
    const prefix = matches[0];
    return size.replace(prefix, `${prefix.length}X`);
  }

  return size;
};
